


































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IGenericJSONMessage,
  IProjectsOutputIntegrationsSlackIntegrationInfo,
} from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import InternalProjectsAPI from '@/api/modules/internal-projects.api'

export default Vue.extend({
  name: 'SlackIntegrationAccordion',

  props: {
    type: {
      type: String as () => EEntities,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    slackIntegration: {
      type: Object as () => IProjectsOutputIntegrationsSlackIntegrationInfo,
      required: true,
    },
  },

  data() {
    return {
      isSubmitting: false,
      isRemoving: false,
      formData: {
        room: '',
      },
    }
  },

  computed: {
    buttonColor(): string {
      return ColorAssistant.getEntityColor(this.type)
    },

    slackAuthorized(): boolean {
      return (
        this.slackIntegration.listChannels &&
        this.slackIntegration.listChannels.length > 0
      )
    },

    rules() {
      return {
        room: [
          {
            required: true,
            trigger: 'submit',
            message: 'You must select a room',
          },
        ],
      }
    },
  },

  watch: {
    'slackIntegration.channelID': {
      immediate: true,
      handler(newVal) {
        this.formData.room = newVal
      },
    },
  },

  methods: {
    async save(room: string): Promise<IGenericJSONMessage> {
      if (this.type === EEntities.MAILBOXES) {
        return await MailboxesAPI.post_SetSlackIntegration(this.entityId, room)
      } else {
        return await InternalProjectsAPI.post_SetSlackIntegration(
          this.entityId,
          room,
        )
      }
    },

    async remove(): Promise<IGenericJSONMessage> {
      if (this.type === EEntities.MAILBOXES) {
        return await MailboxesAPI.post_RemoveSlackIntegration(this.entityId)
      } else {
        return await InternalProjectsAPI.post_RemoveSlackIntegration(
          this.entityId,
        )
      }
    },

    goToSlackOAuthUrl() {
      // @ts-ignore
      window.location.href = this.slackIntegration.oAuthUrl
    },

    async submitHandler() {
      // @ts-ignore
      await this.$refs.form.validate(async valid => {
        if (valid) {
          this.isSubmitting = true
          try {
            const response = await this.save(this.formData.room)
            this.$messaging.showSuccess(response.message)
          } catch (err) {
            this.$error.emit(err, true)
          } finally {
            this.isSubmitting = false
          }
        }
      })
    },

    async removeHandler() {
      this.isRemoving = true
      try {
        const response = await this.remove()
        this.slackIntegration.listChannels = []
        this.$messaging.showSuccess(response.message)
      } catch (err) {
        this.$error.emit(err, true)
      } finally {
        this.isRemoving = false
      }
    },
  },
})
